import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { State, Store } from '@ngrx/store';
import { Payment, PaymentAccount, PaymentStatus } from '@uzurv/clara';
import { PaymentStatusConstants } from '@uzurv/core';
import { CreatePayment } from '../../../store/organization-rider/organization-rider.actions';
import { OrganizationRiderState } from '../../../store/organization-rider/organization-rider.reducer';
import { Observable } from 'rxjs';

export interface NewPaymentDialogData {
  paymentAccounts: Array<PaymentAccount>;
}

export interface NewPaymentFormValues {
  amount: number;
  description: string;
  selectedAccount: PaymentAccount;
}

@Component({
  selector: 'app-new-payment-dialog',
  templateUrl: './new-payment-dialog.component.html',
  styleUrls: ['./new-payment-dialog.component.scss']
})
export class NewPaymentDialogComponent {
  newPaymentForm: UntypedFormGroup;

  constructor(
    private dialogRef: MatDialogRef<NewPaymentDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private store$: Store<State<OrganizationRiderState>>,
    @Inject(MAT_DIALOG_DATA) public data: NewPaymentDialogData
  ) {
    this.newPaymentForm = this.formBuilder.group({
      amount: ['', Validators.required],
      description: ['', Validators.required],
      selectedAccount: [
        {
          paymentAccount: PaymentAccount
        },
        Validators.required
      ]
    });
  }

  get newPayment(): NewPaymentFormValues {
    return this.newPaymentForm.value;
  }

  set newPayment(value: NewPaymentFormValues) {
    this.newPaymentForm.setValue(value);
  }

  close(): void {
    this.dialogRef.close();
  }

  handleSubmitPayment(event): void {
    const payment = new Payment();
    payment.amount = this.newPayment.amount;
    payment.paymentDescription = this.newPayment.description;
    payment.paymentAccount = this.newPayment.selectedAccount;
    payment.paymentStatus = new PaymentStatus();
    payment.paymentStatus.name = PaymentStatusConstants.AWAITING_PROCESSING;

    this.store$.dispatch(CreatePayment({ payload: { dialogRef: this.dialogRef, payment: payment } }));
  }
}
